/* eslint-disable @typescript-eslint/no-empty-function */
// eslint-disable-next-line react/react-in-jsx-scope
import UserManager from "commons/utils/Auth/UserManager";
import { newToast } from "components/ui_kit/Toast";
import React, { createContext, useEffect, useState } from "react";
import WishlistService from "../services/wishListService";
import { useToastNotify } from "./notifyToast";

interface AlertsContextData {
    isLogged: boolean;
    loading: boolean;
    loadingDots: boolean;
    type: string;
    setType: (type: string) => any;
    data: any;
    setData: (data: any) => any;
    show: boolean;
    setShow: (show: boolean) => any;
    setLoading: (show: boolean) => any;
    title: string;
    subtitle: string;
    alerts: any;
    editData: any;
    thetoasts: any;
    getWishList: () => any;
    handleCreateWishList: (data: AlertPayload) => void;
    handleRemoveWishListItemById: (id: string, payload: AlertPayload) => void;
    handleEditWishListItemById: (id: string, payload: AlertPayload) => void;
    setAlerts: any;
    catchErrorUnauthorized: any;
    addNotify: any;
    removeNotify: any;
}

export interface AlertPayload {
    _id?: string;
    situation?: string;
    product: {
        shortDesc?: string;
        brand?: string;
        model?: string;
        priceMin: number;
        priceMax: number;
        yearMin?: number;
        yearMax?: number;
        location: any;
        category: string;
    };
    offers?: {
        total: number;
    };
}

export const AlertsContext = createContext<AlertsContextData>(
    {} as AlertsContextData
);
AlertsContext.displayName = "Alerts";

export const AlertsProvider: React.FC = ({ children }) => {
    const { addNotify, removeNotify } = useToastNotify();
    const [isLogged, setIsLogged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingDots] = useState(true);
    const [type, setType] = useState("");
    const [data, setData] = useState({
        id: "",
        brand: "",
        model: "",
        location: "",
        year_start: "",
        year_end: "",
        price_start: "",
        price_end: "",
        shortDesc: "",
    });
    const [show, setShow] = useState(false);
    const [editData, setEditData] = useState(null);
    const [title] = useState("Meus alertas.");
    const [subtitle] = useState(
        "Receba notificações de produtos que te interessam."
    );
    const [alerts, setAlerts] = useState([]);
    const [thetoasts, SetThetoasts] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    const catchErrorUnauthorized = async (error) => {
        if (error?.response?.status === 401) {
            localStorage.clear();
            window.location.reload();
        }
    };

    const catchErrorAlreadyExist = async (error) => {
        if (error?.response?.status === 409) {
            setShow(false);
            addNotify({
                description: "Alerta já cadastrado!",
                hasButton: false,
                template: "dark_gray",
            });
            return;
        }
    };

    const generateAlertBody = (data: any) => {
        const product = { ...data };
        let productData;
        if (product.category === "carros-motos") {
            const { shortDesc, ...alertPayload } = product;

            productData = alertPayload;
        }

        if (product.category === "outros") {
            const { brand, model, yearMin, yearMax, ...alertPayload } = product;

            productData = alertPayload;
        }

        return productData;
    };

    const getWishList = async () => {
        setLoading(true);
        try {
            const wishListService = new WishlistService();
            const { data } = await wishListService.getWishList();
            if (data) setAlerts(data);
            const dataEdit = data.filter(function (obj) {
                return obj._id == localStorage.getItem("editID");
            })[0];
            setEditData(dataEdit);
        } catch (error) {
            console.log(error.response);
            catchErrorUnauthorized(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCreateWishList = async (data) => {
        const productData = generateAlertBody(data);
        setShow(false);
        setLoading(true);
        try {
            const wishListService = new WishlistService();
            const payload = {
                userId: JSON.parse(localStorage.getItem("user")).id,
                product: productData,
            };
            const response = await wishListService.postWishList(payload);
            if (response) {
                await getWishList();
                addNotify({
                    description: "Novo alerta criado com sucesso",
                    hasButton: false,
                    template: "dark_gray",
                });
            }
        } catch (error) {
            catchErrorAlreadyExist(error);
            const OneToast = newToast(
                "Não foi possivel criar novo alerta",
                "Error"
            );
            SetThetoasts([...thetoasts, OneToast]);
            catchErrorUnauthorized(error);
        } finally {
            setLoading(false);
        }
    };

    const handleReActivateLastDeletedAlert = async (
        id: string,
        alertItem: AlertPayload
    ) => {
        const { product, situation } = alertItem;
        try {
            setLoading(true);
            const wishListService = new WishlistService();
            const response = await wishListService.putWishList(id, {
                situation,
                product,
            });
            setShow(false);
            if (response) {
                await getWishList();
                addNotify({
                    description: "Alerta recuperado com sucesso",
                    hasButton: false,
                    template: "dark_gray",
                });
            }
        } catch (error) {
            const OneToast = newToast("Erro ao atualizar alerta", "Error");
            SetThetoasts([...thetoasts, OneToast]);
            catchErrorUnauthorized(error);
        } finally {
            setLoading(false);
        }
    };

    const handleRemoveWishListItemById = async (
        id: string,
        alertItem: AlertPayload
    ) => {
        setLoading(true);
        try {
            const wishListService = new WishlistService();
            const response = await wishListService.deleteWishList(id);
            if (response) {
                await getWishList();
                addNotify({
                    description: "Alerta excluído",
                    hasButton: true,
                    template: "dark_gray",
                    buttonLabel: "Desfazer",
                    onClickButton: () =>
                        handleReActivateLastDeletedAlert(id, alertItem),
                });
            }
        } catch (error) {
            const OneToast = newToast("Erro ao excluir alerta", "Error");
            SetThetoasts([...thetoasts, OneToast]);
            catchErrorUnauthorized(error);
        } finally {
            setLoading(false);
        }
    };

    const handleEditWishListItemById = async (
        id: string,
        payload: Omit<AlertPayload, "_id" | "situation" | "offers">
    ) => {
        const productData = generateAlertBody(payload);
        setLoading(true);
        try {
            const body = {
                product: productData,
            };
            const wishListService = new WishlistService();
            const response = await wishListService.putWishList(id, body);
            setShow(false);
            if (response) {
                addNotify({
                    description: "Alerta editado com sucesso",
                    hasButton: false,
                    template: "dark_gray",
                });
            }
        } catch (error) {
            setShow(false);
            const OneToast = newToast("Erro ao atualizar alerta", "Error");
            SetThetoasts([...thetoasts, OneToast]);
            catchErrorUnauthorized(error);
        } finally {
            await getWishList();
            setLoading(false);
        }
    };

    useEffect(() => {
        setIsLogged(UserManager.isLogin());
        if (UserManager.isLogin()) {
            getWishList();
        }
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const alert_id = urlParams.get("alert_id");
        alert_id && localStorage.setItem("editID", alert_id);
    }, []);

    return (
        <AlertsContext.Provider
            value={{
                isLogged,
                loading,
                loadingDots,
                type,
                setType,
                data,
                setData,
                show,
                setShow,
                title,
                subtitle,
                alerts,
                thetoasts,
                getWishList,
                handleCreateWishList,
                handleRemoveWishListItemById,
                handleEditWishListItemById,
                editData,
                setAlerts,
                catchErrorUnauthorized,
                setLoading,
                addNotify,
                removeNotify,
            }}
        >
            {children}
        </AlertsContext.Provider>
    );
};
